import React from 'react'
// CopyRight Area
const CopyRight = () => {
    return (
        <>
            <div id="copy_right">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copy-right-area">
                                <p>Copyright @2024 <span>MV AUTOTRASLADOS.</span> Todos los derechos reservados | Dev By: @DiWolf </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CopyRight
